<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'IconCheckout',
    props: {
      isActive: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      getColor() {
        return this.isActive ? '#50869C' : '#CCCCCC'
      },
    },
  })
</script>

<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="23.5" :stroke="getColor" />
    <path
      :fill="getColor"
      d="M23.598 21.678C23.422 21.502 23.334 21.278 23.334 21.006C23.334 20.734 23.422 20.51 23.598 20.334L24.438 19.47H21.39C21.118 19.47 20.8898 19.3778 20.7055 19.1935C20.5212 19.0092 20.4293 18.7813 20.43 18.51C20.43 18.238 20.5221 18.0098 20.7064 17.8255C20.8908 17.6412 21.1186 17.5493 21.39 17.55H24.438L23.574 16.686C23.382 16.494 23.2898 16.27 23.2975 16.014C23.3052 15.758 23.4053 15.534 23.598 15.342C23.79 15.166 24.014 15.0738 24.27 15.0655C24.526 15.0572 24.75 15.1493 24.942 15.342L27.438 17.838C27.534 17.934 27.6018 18.038 27.6415 18.15C27.6812 18.262 27.7013 18.382 27.702 18.51C27.702 18.638 27.6818 18.758 27.6415 18.87C27.6012 18.982 27.5333 19.086 27.438 19.182L24.942 21.678C24.766 21.854 24.5461 21.9461 24.2824 21.9545C24.0188 21.9628 23.7906 21.8706 23.598 21.678ZM19.47 29.07C18.734 29.07 18.1778 28.7538 17.8015 28.1215C17.4252 27.4892 17.4213 26.8613 17.79 26.238L19.086 23.886L15.63 16.59H14.67C14.398 16.59 14.1698 16.4978 13.9855 16.3135C13.8012 16.1292 13.7093 15.9013 13.71 15.63C13.71 15.358 13.8021 15.1298 13.9864 14.9455C14.1708 14.7612 14.3986 14.6693 14.67 14.67H16.23C16.406 14.67 16.574 14.718 16.734 14.814C16.894 14.91 17.014 15.046 17.094 15.222L20.958 23.31H27.678L31.11 17.094C31.19 16.934 31.3061 16.8098 31.4584 16.7215C31.6108 16.6332 31.7746 16.5893 31.95 16.59C32.318 16.59 32.5941 16.75 32.7784 17.07C32.9628 17.39 32.9666 17.71 32.79 18.03L29.358 24.222C29.182 24.542 28.95 24.79 28.662 24.966C28.374 25.142 28.046 25.23 27.678 25.23H20.526L19.47 27.15H30.03C30.302 27.15 30.5301 27.2421 30.7144 27.4265C30.8988 27.6108 30.9906 27.8386 30.99 28.11C30.99 28.382 30.8978 28.6101 30.7135 28.7945C30.5292 28.9788 30.3013 29.0706 30.03 29.07H19.47Z"
    />
    <path
      :fill="getColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.4701 31.23C19.0724 31.23 18.7501 31.5523 18.7501 31.95C18.7501 32.3476 19.0724 32.67 19.4701 32.67C19.8677 32.67 20.1901 32.3476 20.1901 31.95C20.1901 31.5523 19.8677 31.23 19.4701 31.23ZM17.3101 31.95C17.3101 30.757 18.2771 29.79 19.4701 29.79C20.663 29.79 21.6301 30.757 21.6301 31.95C21.6301 33.1429 20.663 34.11 19.4701 34.11C18.2771 34.11 17.3101 33.1429 17.3101 31.95Z"
    />
    <path
      :fill="getColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0699 31.23C28.6723 31.23 28.3499 31.5523 28.3499 31.95C28.3499 32.3476 28.6723 32.67 29.0699 32.67C29.4676 32.67 29.7899 32.3476 29.7899 31.95C29.7899 31.5523 29.4676 31.23 29.0699 31.23ZM26.9099 31.95C26.9099 30.757 27.877 29.79 29.0699 29.79C30.2628 29.79 31.2299 30.757 31.2299 31.95C31.2299 33.1429 30.2628 34.11 29.0699 34.11C27.877 34.11 26.9099 33.1429 26.9099 31.95Z"
    />
  </svg>
</template>

<style scoped lang="scss"></style>
